import React from "react";
import { Outlet } from "react-router-dom";
import SidebarComercial from "../componentes/Sidebar/SidebarComercial";

function Comercial() {
  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <div className="h-full">
        <SidebarComercial />
      </div>
      {/* Container principal com rolagem discreta */}
      <div className="flex-grow flex flex-col overflow-auto bg-gray-50 custom-scrollbar">
        <Outlet />
      </div>
    </div>
  );
}

export default Comercial;
